import React, { useState, useEffect } from 'react';
import './LiveFeed.css';
import { useTranslation } from 'react-i18next';

const LiveFeed = () => {
  const { t } = useTranslation();
  const [notifications, setNotifications] = useState([]);

  // Фейковые данные для лайв-ленты
  const fakeUsers = [
    'Alex_2024', 'Maya_Star', 'John_Doe', 'Sarah_Win', 'Mike_Luck',
    'Anna_Gold', 'David_Pro', 'Lisa_Queen', 'Tom_Hero', 'Emma_Sweet',
    'Max_Power', 'Kate_Beauty', 'Nick_Cool', 'Rose_Love', 'Sam_Winner'
  ];

  const prizes = [
    // Обычные призы (часто)
    { name: 'Heart', price: 15, image: 'small-prize-heart.png', rarity: 'common', chance: 40 },
    { name: 'Bear', price: 15, image: 'small-prize-bear.png', rarity: 'common', chance: 35 },
    { name: 'Cup', price: 30, image: 'small-prize-cup.png', rarity: 'common', chance: 30 },
    { name: 'Gift', price: 25, image: 'small-prize-gift.png', rarity: 'common', chance: 25 },
    { name: 'Rose', price: 25, image: 'small-prize-rose.png', rarity: 'common', chance: 25 },
    { name: 'Flowers', price: 25, image: 'small-prize-flowers.png', rarity: 'common', chance: 20 },
    
    // Средние призы (реже)
    { name: 'Rocket', price: 50, image: 'small-prize-rocket.png', rarity: 'uncommon', chance: 15 },
    { name: 'Ring', price: 100, image: 'small-prize-ring.png', rarity: 'uncommon', chance: 10 },
    { name: 'Cake Slice', price: 50, image: 'small-prize-cake-slice.png', rarity: 'uncommon', chance: 12 },
    
    // Главные призы (очень редко)
    { name: 'Homemade cake', price: 360, image: 'prize-cake.png', rarity: 'rare', chance: 3 },
    { name: 'Lol Pop', price: 300, image: 'prize-lollipop.png', rarity: 'rare', chance: 5 }
  ];

  const generateNotification = () => {
    const user = fakeUsers[Math.floor(Math.random() * fakeUsers.length)];
    
    // Выбираем приз на основе вероятности
    const totalChance = prizes.reduce((sum, prize) => sum + prize.chance, 0);
    let randomPoint = Math.random() * totalChance;
    let selectedPrize = prizes[0];
    
    for (const prize of prizes) {
      if (randomPoint < prize.chance) {
        selectedPrize = prize;
        break;
      }
      randomPoint -= prize.chance;
    }

    const notification = {
      id: Date.now() + Math.random(),
      user,
      prize: selectedPrize,
      timestamp: new Date()
    };

    setNotifications(prev => {
      const newNotifications = [notification, ...prev.slice(0, 4)]; // Максимум 5 уведомлений
      return newNotifications;
    });
  };

  useEffect(() => {
    // Генерируем первое уведомление сразу
    generateNotification();

    // Интервал для новых уведомлений (2-8 секунд)
    const interval = setInterval(() => {
      generateNotification();
    }, Math.random() * 6000 + 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="live-feed">
      <div className="live-feed-header">
        <div className="live-indicator">
          <span className="live-dot"></span>
          <span className="live-text">{t('live')}</span>
        </div>
        <h3>{t('recent_wins')}</h3>
      </div>
      
      <div className="notifications-container">
        {notifications.map((notification) => (
          <div 
            key={notification.id} 
            className={`notification-item ${notification.prize.rarity}`}
          >
            <div className="notification-content">
              <img 
                src={`/prizes/${notification.prize.image}`} 
                alt={notification.prize.name}
                className="prize-icon"
              />
              <span className="prize-price"><img src="/icons/stars-symbol.png" alt="stars" className="case-star-icon-nova" style={{width: 14, height: 14, marginRight: 2}} />{notification.prize.price}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveFeed; 